import InputComponent from "V2.0/components/InputComponent";

export default TriggerCoachConditional;

function TriggerCoachConditional(props) {
  const { coachTriggerState, setCoachTriggerState, isUnlocked } = props;

  return (
    <>
      <InputComponent
        type="textArea"
        label="Keywords (comma-seperated)"
        style={{ fontSize: "13px", height: "200px" }}
        value={coachTriggerState.triggerConditions}
        onChange={(e) => {
          setCoachTriggerState((prev) => {
            return {
              ...prev,
              triggerConditions: e.target.value,
            };
          });
        }}
        disabled={!isUnlocked}
      />
    </>
  );
}
